import React from "react";
import InfoPopupHover from "../components/InfoPopupHover";
import { FaInfoCircle } from "react-icons/fa";

export default function MarketingBanner(props) {
  const { offer, onImage } = props;

  let idx = -1;

  //rank sorting

  let ma = [];

  if (offer.MarketingActions) {
    ma = [...offer.MarketingActions];
  }
  ma.sort((a, b) => b.rank - a.rank);

  //console.log(ma);

  for (let i = 0; i < ma.length; i++) {
    if ((ma[i].typ_id === "0018-0001" || ma[i].typ_id === "0018-0002") && ma[i].onpage == "0021-0001") {
      idx = i;
      break;
    }
  }

  return (
    <>
      {idx > -1 &&
        ma &&
        ma.length > idx &&
        ma[idx] &&
        ma[idx].MarketingProperties &&
        ma[idx].MarketingProperties.text &&
        ma[idx].onpage == "0021-0001" && (
          <InfoPopupHover
            trigger={
              <div style={{ display: "flex" }}>
                <div
                  className="marketingbanner"
                  style={{
                    display: "flex",
                    marginLeft: onImage ? 0 : 0,
                    marginTop: 0,
                    borderRadius: 0,
                    maxHeight: 32
                  }}
                >
                  
                  <div
                   style = {  ma.MarketingProperties?.styleD ? ma.MarketingProperties.styleD:{}  }
                    className="marketingbannertext"

                  >
                    <div
                      className="hotelinfos9"
                      dangerouslySetInnerHTML={{
                        __html: ma[idx].MarketingProperties.text,
                      }}
                    />

                    <FaInfoCircle
                      style={{ verticalAlign: "middle" }}
                      className="infowhite" />
                  </div>
                  {ma[idx].expiration && (
                    <div className="marketingexperation">{ma[0].expiration}</div>
                  )}

                </div>

                <div
                  className="marketingbanner2"
                  style={{
                    marginLeft: 0, marginTop: 0,
                  }}
                >
                  <svg height="32" width="32">
                    <polygon points="0,0 0,32 32,0" />
                    Sorry, your browser does not support inline SVG.
                  </svg>
                </div>
              </div>
            }
            content={ma[idx].MarketingProperties?.mouseover}
            position={"bottom center"}
          ></InfoPopupHover>

        )}
    </>
  );
}
